import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
  getUserListApi,
  logoutUserFromAllDevice,
  sendOtpAPi,
  sendUserWhatsappApi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from './UserStatus'
import { dateFormat, dateFormatUtc } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import {
  Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, FormControlLabel, InputLabel, Radio, RadioGroup, Select as MuiSelect,
  MenuItem, TextField, Typography
} from "@mui/material";
import constants from "../../utils/constants";
import { CustomTabs, CustomTab } from "../../components/tabs/Tabs";
import UserTagEditor from "../../components/PowerCustomer/UserTagEditor";
import { sendTargetedNotificationApi, scheduleTargetedNotificationApi } from "../../services/notificationManagement";


const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;
const customerTypes = ["normal", "potential", "power"];
const customerTypeLabels = ["Normal Customer", "Potential Power Customer", "Power Customer"];


// console.log('Gender', gender)

const UserManagement = () => {
  const [managementTab, setManagementTab] = useState(0);
  const URL = constants.SERVER_API;
  const [searchParam, setSearchParam] = useSearchParams()
  let activePage = +searchParam.get('page') || 1
  let pageLimit = +searchParam.get('limit') || 10
  const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
  const [search, setSearch] = useState(
    getLocalStorage("userList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState([]);
  const [problemList, setProblemList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [logoutUserModel, setLogoutUserModel] = useState(false);

  const [buttonref, buttonLoader] = useButtonLoader("Logout");


  const [WriteOtpModal, setwriteOtpModal] = useState(false);
  const genderValue = searchParam.get("gender") || "";
  const consultationCountValue = searchParam.get("ConsultationCount") || "";
  // const [statusSearch, setStatusSearch] = useState('')
  const registrationDate = searchParam.get("registrationDate") || "";
  const problemValue = searchParam.get("problem") || "";
  // const [endDateSearch, setEndDateSearch] = useState('')
  
  // Time range filter states
  const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
  const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
  const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
  
  // Sort filter states
  const [sortBy, setSortBy] = useState(searchParam.get("sortBy") || "");
  const [walletRange, setWalletRange] = useState(searchParam.get("walletRange") || "");
  const [minimumSpending, setMinimumSpending] = useState(searchParam.get("minimumSpending") || "");
  const [supportTagFilter, setSupportTagFilter] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectingAll, setSelectingAll] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [sendingNotification, setSendingNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({ title: "", message: "", titleHi: "", messageHi: "", titleKn: "", messageKn: "", scheduledAt: "" });
  const [whatsappModal, setWhatsappModal] = useState(false);
  const [sendingWhatsapp, setSendingWhatsapp] = useState(false);
  const [whatsappSendMode, setWhatsappSendMode] = useState("all");
  const [whatsappCampaignName, setWhatsappCampaignName] = useState("");
  const [spendWindow, setSpendWindow] = useState(null);
  const [filterVersion, setFilterVersion] = useState(0);
  const latestListRequest = useRef(0);
  
  // Time range options
  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];

  // Sort options
  const sortOptions = [
    { value: "", label: "Default Sort" },
    { value: "wallet_desc", label: "Wallet (High to Low)" },
    { value: "wallet_asc", label: "Wallet (Low to High)" },
    { value: "spending_desc", label: "Spending (High to Low)" },
    { value: "spending_asc", label: "Spending (Low to High)" },
    { value: "name_asc", label: "Name (A to Z)" },
    { value: "name_desc", label: "Name (Z to A)" },
    { value: "registration_desc", label: "Registration (Newest)" },
    { value: "registration_asc", label: "Registration (Oldest)" }
  ];

  useEffect(() => {
    setLocalStorage("userList", "search", search);
  }, [search]);

  useEffect(() => {
    setSelectedUserIds([]);
  }, [debounceValue]);

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { userId: statusId };
      const { data } = await logoutUserFromAllDevice(sendData);
      if (data.code === 200) {
        console.log("Date", data);
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/user/download`;
      const params = {
        filter: {}
      };
      
      // Add all current filters to the export
      if(search) {
        params.filter.search = search;
      }
      if (genderValue) {
        params.filter.gender = genderValue;
      }
      if (problemValue) {
        params.filter.problems = problemValue;
      }
      if (registrationDate) {
        params.filter.registerDate = registrationDate;
      }
      if (consultationCountValue) {
        params.consultationCountFilter = consultationCountValue;
      }
      if (timeRange) {
        params.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        params.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        params.filter.timeRangeEndDate = timeRangeEndDate;
      }
      
      requestDownload(url, `user-excel-file-${dateFormat(new Date())}`, params);
    } catch (e) {
      console.log(e.message);
    }
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //*********Logout handler function********* */
  const userLogoutHandler = (id) => {
    setStatusId(id);
    setLogoutUserModel(true);
  };

  // gender handler

  const genderHandler = (value) => {
    setSelectedUserIds([]);
    if (genderValue === value) {
      searchParam.delete("gender");
    } else {
      searchParam.set("gender", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // Problem handler

  const problemValueHandler = (value) => {
    setSelectedUserIds([]);
    if (problemValue === value) {
      searchParam.delete("problem");
    } else {
      searchParam.set("problem", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  // consultation count handler

  const TotalconsultationHandler = (value) => {
    setSelectedUserIds([]);
    if (consultationCountValue === value) {
      searchParam.delete("ConsultationCount");
    } else {
      searchParam.set("ConsultationCount", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const handleManagementTabChange = (_, value) => {
    setManagementTab(value);
    setSearch("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    setSortBy("");
    setWalletRange("");
    setMinimumSpending("");
    setSupportTagFilter("");
    setSelectedUserIds([]);
    setSpendWindow(null);
    [
      "page", "gender", "problem", "registrationDate", "ConsultationCount", "timeRange",
      "timeRangeStartDate", "timeRangeEndDate", "sortBy", "walletRange", "minimumSpending"
    ].forEach((key) => searchParam.delete(key));
    setSearchParam(searchParam);
  };

    const handlePageLimitChange = (event) => {
        const newLimit = parseInt(event.target.value);
        // setPageLimit(newLimit);
        searchParam.set("limit", newLimit);
    setSearchParam(searchParam);
        // setActivePage(1); // Reset to first page when changing limit
    };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    setSortBy("");
    setWalletRange("");
    setMinimumSpending("");
    setSupportTagFilter("");
    setSelectedUserIds([]);
    setSpendWindow(null);
    searchParam.delete("limit");
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("problem");
    searchParam.delete("registrationDate");
    searchParam.delete("ConsultationCount");
    searchParam.delete("timeRange");
    searchParam.delete("timeRangeStartDate");
    searchParam.delete("timeRangeEndDate");
    searchParam.delete("sortBy");
    searchParam.delete("walletRange");
    searchParam.delete("minimumSpending");
    setSearchParam(searchParam);
    setFilterVersion((version) => version + 1);
  };
  const applyFilter = () => {
    if (timeRange === "custom" && (!timeRangeStartDate || !timeRangeEndDate || timeRangeStartDate > timeRangeEndDate)) {
      toastMessage("Select a valid start and end date", "error");
      return;
    }
    // Update URL parameters for time range
    if (timeRange) {
      searchParam.set("timeRange", timeRange);
    } else {
      searchParam.delete("timeRange");
    }
    if (timeRangeStartDate) {
      searchParam.set("timeRangeStartDate", timeRangeStartDate);
    } else {
      searchParam.delete("timeRangeStartDate");
    }
    if (timeRangeEndDate) {
      searchParam.set("timeRangeEndDate", timeRangeEndDate);
    } else {
      searchParam.delete("timeRangeEndDate");
    }
    if (minimumSpending) {
      searchParam.set("minimumSpending", minimumSpending);
    } else {
      searchParam.delete("minimumSpending");
    }
    if (walletRange) {
      searchParam.set("walletRange", walletRange);
    } else {
      searchParam.delete("walletRange");
    }
    searchParam.delete("page");
    setSelectedUserIds([]);
    setSearchParam(searchParam);
    setFilterVersion((version) => version + 1);
  };

  const buildUserListPayload = (debouncedSearch, options = {}) => {
    const sendData = {
      page: String(activePage),
      limit: String(pageLimit),
      filter: { customerType: customerTypes[managementTab] || "normal" },
      ...options
    };
    if (debouncedSearch) sendData.search = debouncedSearch;
    if (problemValue) sendData.filter.problems = problemValue;
    if (genderValue) sendData.filter.gender = genderValue;
    if (registrationDate) sendData.filter.registerDate = registrationDate;
    if (consultationCountValue) sendData.consultationCountFilter = consultationCountValue;
    if (timeRange) sendData.filter.timeRange = timeRange;
    if (timeRangeStartDate) sendData.filter.timeRangeStartDate = timeRangeStartDate;
    if (timeRangeEndDate) sendData.filter.timeRangeEndDate = timeRangeEndDate;
    if (sortBy) sendData.sortBy = sortBy;
    if (minimumSpending) sendData.filter.minimumSpending = Number(minimumSpending);
    if (walletRange) {
      const [minimumWallet, maximumWallet] = walletRange.split("-");
      sendData.filter.minimumWallet = Number(minimumWallet);
      if (maximumWallet !== "above") sendData.filter.maximumWallet = Number(maximumWallet);
    }
    if (supportTagFilter.trim()) sendData.filter.supportTag = supportTagFilter.trim();
    return sendData;
  };

  //------------------usre-listing-Api----------------------------------
  const getUserList = async (debounceValue) => {
    const requestId = latestListRequest.current + 1;
    latestListRequest.current = requestId;
    try {
      showLoader();
      const sendData = buildUserListPayload(debounceValue);

      const { data } = await getUserListApi(sendData);
      if (requestId !== latestListRequest.current) return;
      if (data.code === 200) {
        setUserList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        setSpendWindow(data?.result?.spendWindow || null);
        // scrollToUp();
      } else {
        setUserList([]);
        setTotal(0);
        setSpendWindow(null);
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      if (requestId !== latestListRequest.current) return;
      console.log("error", error);
      setUserList([]);
      setTotal(0);
      toastMessage(error?.response?.data?.message || "Failed to load users", "error", "userList");
    } finally {
      if (requestId === latestListRequest.current) hideLoader();
    }
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const logoutCloseModel = () => {
    setLogoutUserModel(false);
    setStatusId("");
  };

  // problem list handler function

  const fetchProblemHandler = async () => {
    try {
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setProblemList(data?.result?.categoryList || []);
      } else {
        setProblemList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  
  

  const handleRegistrationDate = (date) => {
    setSelectedUserIds([]);
    const utcDateString = dateFormatUtc(date);
    searchParam.delete("page");
    searchParam.delete("limit");
    searchParam.set("registrationDate", utcDateString);
    setSearchParam(searchParam);
  };

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  // Sort handler
  const handleSortChange = (value) => {
    setSortBy(value);
    if (value) {
      searchParam.set("sortBy", value);
    } else {
      searchParam.delete("sortBy");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  const handleSelectUser = (userId) => {
    setSelectedUserIds((current) => current.includes(userId)
      ? current.filter((id) => id !== userId)
      : [...current, userId]);
  };

  const handleSelectAllFiltered = async (checked) => {
    if (!checked) {
      setSelectedUserIds([]);
      return;
    }
    try {
      setSelectingAll(true);
      const { data } = await getUserListApi(buildUserListPayload(debounceValue, { fetchAllIds: true }));
      if (data?.code !== 200) throw new Error(data?.message || "Unable to select filtered customers");
      setSelectedUserIds(data?.result?.list || []);
      toastMessage(`Selected ${data?.result?.total || 0} filtered customer(s)`, "success");
    } catch (error) {
      toastMessage(error?.response?.data?.message || error.message || "Unable to select filtered customers", "error");
    } finally {
      setSelectingAll(false);
    }
  };

  const closeNotificationModal = () => {
    if (sendingNotification) return;
    setNotificationModal(false);
  };

  const handleSendNotification = async (schedule = false) => {
    const title = notificationData.title.trim();
    const message = notificationData.message.trim();
    if (!selectedUserIds.length || !title || !message) {
      toastMessage("Select customers and enter notification title and message", "error");
      return;
    }
    if (schedule && !notificationData.scheduledAt) {
      toastMessage("Select schedule date and time", "error");
      return;
    }
    try {
      setSendingNotification(true);
      const payload = {
        userIds: selectedUserIds,
        title,
        message,
        titleHi: notificationData.titleHi?.trim() || "",
        messageHi: notificationData.messageHi?.trim() || "",
        titleKn: notificationData.titleKn?.trim() || "",
        messageKn: notificationData.messageKn?.trim() || "",
      };
      const scheduledAt =
        schedule && notificationData.scheduledAt && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(notificationData.scheduledAt)
          ? `${notificationData.scheduledAt}:00+05:30`
          : notificationData.scheduledAt;
      const response = schedule
        ? await scheduleTargetedNotificationApi({ ...payload, scheduledAt })
        : await sendTargetedNotificationApi(payload);
      if (response?.data?.code !== 200) throw new Error(response?.data?.message || "Unable to send notification");
      toastMessage(`Notification ${schedule ? "scheduled" : "sent"} successfully`, "success");
      setNotificationData({ title: "", message: "", titleHi: "", messageHi: "", titleKn: "", messageKn: "", scheduledAt: "" });
      setSelectedUserIds([]);
      setNotificationModal(false);
    } catch (error) {
      toastMessage(error?.response?.data?.message || error.message || "Unable to send notification", "error");
    } finally {
      setSendingNotification(false);
    }
  };

  const openWhatsappModal = () => {
    setWhatsappSendMode(selectedUserIds.length ? "selected" : "all");
    setWhatsappModal(true);
  };

  const closeWhatsappModal = () => {
    if (sendingWhatsapp) return;
    setWhatsappModal(false);
  };

  const handleSendWhatsapp = async () => {
    const campaignName = whatsappCampaignName.trim();
    if (!campaignName) {
      toastMessage("Enter AiSensy campaign name", "error");
      return;
    }
    if (whatsappSendMode === "selected" && !selectedUserIds.length) {
      toastMessage("Select customers, or choose Send to all matching", "error");
      return;
    }
    if (whatsappSendMode === "all" && !total) {
      toastMessage("No matching customers in this date range", "error");
      return;
    }
    try {
      setSendingWhatsapp(true);
      const { data } = await sendUserWhatsappApi({
        ...buildUserListPayload(debounceValue),
        campaignName,
        sendMode: whatsappSendMode,
        userIds: whatsappSendMode === "selected" ? selectedUserIds : undefined,
      });
      if (data?.code !== 200) throw new Error(data?.message || "Unable to send WhatsApp");
      const result = data.result || {};
      toastMessage(
        `WhatsApp ${whatsappSendMode === "selected" ? "to selected" : "to all matching"}: ${result.sent || 0} sent, ${result.failed || 0} failed${result.remaining ? `, ${result.remaining} remaining` : ""}`,
        "success"
      );
      setWhatsappCampaignName("");
      setSelectedUserIds([]);
      setWhatsappModal(false);
    } catch (error) {
      toastMessage(error?.response?.data?.message || error.message || "Unable to send WhatsApp", "error");
    } finally {
      setSendingWhatsapp(false);
    }
  };

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   getOrder(activePage, debounceValue)
  // }, [searchParam, debounceValue])

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    if (!genderValue) {
      searchParam.delete("gender");
    }
    if (!problemValue) {
      searchParam.delete("problem");
    }
    if (!timeRange) {
      searchParam.delete("timeRange");
    }
    if (!timeRangeStartDate) {
      searchParam.delete("timeRangeStartDate");
    }
    if (!timeRangeEndDate) {
      searchParam.delete("timeRangeEndDate");
    }
    if (!sortBy) {
      searchParam.delete("sortBy");
    }
    if (!minimumSpending) {
      searchParam.delete("minimumSpending");
    }
    if (!walletRange) {
      searchParam.delete("walletRange");
    }
    setSearchParam(searchParam);
    getUserList(debounceValue);
  }, [searchParam, debounceValue, managementTab, filterVersion]);

  useEffect(() => {
    fetchProblemHandler();
  }, []);

  return (
    <>
      <OTPModalCNF verifiedHandle={() => {
        console.log('OTP Verified Successfully!')
      }} />
      <DownloadPasswordModal />
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            {/* <div className="user_management_heading"> */}
            <h4 className="Title">User Management</h4>
            <div className="block_user_button">
            <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span>
              <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    // onClick={() => setAddConsultantModel(true)}
                    >
                      {/* <AddIcon /> */}
                      Deleted User
                    </button>
                  </div>
                </Link>
              </div>
            </div>
            {/* </div> */}
          </div>
          <Box sx={{ width: "100%", mb: 2 }}>
            <CustomTabs value={managementTab} onChange={handleManagementTabChange}>
              <CustomTab label="Normal Customers" />
              <CustomTab label="Potential Power Customers" />
              <CustomTab label="Power Customers" />
            </CustomTabs>
          </Box>

          <div className="FilterBox FilterArea">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>  
            {/* <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${ConsultationCount && "active"}`}
                  value={consultationCountValue || ""}
                  onChange={(e) => TotalconsultationHandler(e.target.value)}
                >
                  <option value="">Total Consultation</option>
                  {ConsultationCount &&
                    ConsultationCount.length > 0 &&
                    ConsultationCount.map((ConsultationCount, index) => {
                      return (
                        <option value={ConsultationCount.value} key={ConsultationCount.id}>
                          {ConsultationCount.name}
                        </option>
                      );
                    })}
                </Select>
              </div> */}

              {/* Time Range Filter — spend in this period, not registration date */}
              <div className="form-group select_sm_width" style={{ minWidth: '170px', flex: '0 0 auto' }}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Spend date range</InputLabel>
                  <MuiSelect
                    value={timeRange}
                    onChange={(e) => handleTimeRangeChange(e.target.value)}
                    label="Spend date range"
                  >
                    <MenuItem value="">
                      <em>All time spend</em>
                    </MenuItem>
                    {timeRangeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
              </div>
              
              {timeRange === 'custom' && (
                <>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="Start Date"
                      value={timeRangeStartDate}
                      onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="End Date"
                      value={timeRangeEndDate}
                      inputProps={{ min: timeRangeStartDate }}
                      onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </>
              )}

              {/* Gender-Filter */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${genderValue && "active"}`}
                  value={genderValue || ""}
                  onChange={(e) => genderHandler(e.target.value)}
                >
                  <option value="">Gender</option>
                  {/* <option value="male">Male</option>
                  <option value="female">Female</option> */}
                  {gender &&
                    gender.length > 0 &&
                    gender.map((gender, index) => {
                      return (
                        <option value={gender.value} key={gender.id}>
                          {gender.name}
                        </option>
                      );
                    })}
                </Select>
              </div>
              <div className="form-group search_lg_size" style={{ minWidth: 190 }}>
                <input type="text" className="form-control" placeholder="Filter support tag"
                  value={supportTagFilter} onChange={(event) => setSupportTagFilter(event.target.value)} />
              </div>

              {/* Sort Filter */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${walletRange && "active"}`}
                  value={walletRange}
                  onChange={(event) => setWalletRange(event.target.value)}
                >
                  <option value="">All Wallet Balances</option>
                  <option value="0-500">Wallet: 0 - 500</option>
                  <option value="1000-5000">Wallet: 1,000 - 5,000</option>
                  <option value="5000-10000">Wallet: 5,000 - 10,000</option>
                  <option value="10000-above">Wallet: 10,000 &amp; above</option>
                </Select>
              </div>
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${sortBy && "active"}`}
                  value={sortBy || ""}
                  onChange={(e) => handleSortChange(e.target.value)}
                >
                  {sortOptions.map((option) => (
                    <option value={option.value} key={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </div>
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${minimumSpending && "active"}`}
                  value={minimumSpending}
                  onChange={(event) => setMinimumSpending(event.target.value)}
                >
                  <option value="">All Spending</option>
                  {[100, 250, 500, 750].map((amount) => (
                    <option key={amount} value={amount}>
                      ₹{amount.toLocaleString("en-IN")} and above
                    </option>
                  ))}
                </Select>
              </div>
              {/* Problem filter */}
              {/* <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${problemValue && "active"}`}
                  value={problemValue || ""}
                  onChange={(e) => problemValueHandler(e.target.value)}
                >
                  <option value={""} key={1}>
                    Problem
                  </option>
                  {problemList &&
                    problemList.length > 0 &&
                    problemList.map((problem, index) => {
                      return (
                        <option value={problem._id} key={problem._id}>
                          {charLimit(problem.title, 20)}
                        </option>
                      );
                    })}
                </Select>
              </div> */}
             <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                                <SecondaryButton onClick={applyFilter}>
                                    Apply
                                </SecondaryButton>
                                <SecondaryButton onClick={refreshHandler}>
                                    Clear
                                </SecondaryButton>
                                <Button
                                  variant="contained"
                                  disabled={!selectedUserIds.length}
                                  onClick={() => setNotificationModal(true)}
                                  sx={{ whiteSpace: "nowrap", bgcolor: "#ff8989", "&:hover": { bgcolor: "#ff6b6b" } }}
                                >
                                  Notify ({selectedUserIds.length})
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={openWhatsappModal}
                                  sx={{ whiteSpace: "nowrap", bgcolor: "#ff8989", "&:hover": { bgcolor: "#ff6b6b" } }}
                                >
                                  WhatsApp Marketing
                                </Button>
                            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>
                    <Checkbox
                      size="small"
                      checked={total > 0 && selectedUserIds.length === total}
                      indeterminate={selectedUserIds.length > 0 && selectedUserIds.length < total}
                      disabled={!total || selectingAll}
                      onChange={(event) => handleSelectAllFiltered(event.target.checked)}
                      inputProps={{ "aria-label": "Select all filtered customers" }}
                    />
                  </th>
                  <th>S. No.</th>
                  {/* <th>User Id</th> */}
                  <th>Profile</th>
                  <th>Name</th>
                  <th>User Id</th>
                  <th>Phone Number</th>
                  {/* <th>Status</th> */}
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Registration Date</th>
                  <th>Total Attempts</th>
                  <th>Total Completed</th>
                  {/* <th>Total Consultation</th> */}
                  <th>Wallet</th>
                  <th>
                    Spending
                    {spendWindow?.startDate && spendWindow?.endDate ? (
                      <div style={{ fontSize: 11, fontWeight: 400, color: "#666" }}>
                        {spendWindow.startDate} – {spendWindow.endDate}
                      </div>
                    ) : null}
                  </th>
                  <th>Support Tags</th>
                  <th>Customer Type</th>
                  {managementTab === 2 && <th>Power Origin</th>}
                  {managementTab === 2 && <th>Power Customer Since</th>}
                  <th className="text-center"> Action </th>
                  <th>Logout from all Device</th>
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => {
                    console.log("user ===>",user)
                    return (
                      <React.Fragment key={index}>
                        <tr>
                        <td>
                          <Checkbox
                            size="small"
                            checked={selectedUserIds.includes(user._id)}
                            onChange={() => handleSelectUser(user._id)}
                            inputProps={{ "aria-label": `Select ${user.name || user.userId || "customer"}` }}
                          />
                        </td>
                        <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                      
                          {/* <td>{user?._id}</td> */}
                          <td className="user_profile_image">
                            <img
                              src={user.profileImage || profileImage}
                              alt={`${user.name} profile image`}
                            />
                          </td>
                          <td>{user?.name || "---"}</td>
                          <td>{user?.userId || "---"}</td>
                          <td>
                            {user.phone ? (
                              <a href={`tel:${user.phone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
                                {user.phone}
                              </a>
                            ) : (
                              "---"
                            )}
                          </td>

                          <td>{user.email || "---"}</td>
                          <td>
                            {user.gender
                              ? CapitalizeFirstWord(user.gender)
                              : "---"}
                          </td>
                          <td>{dateFormat(user.createdAt) || "---"}</td>
                          <td>{user.totalAttempts || "0"}</td>
                          <td>{user.totalCompleted || "0"}</td>
                          {/* <td>{user.totalNumberOfConsultations || "0"}</td> */}
                          <td>{Number(user.wallet || 0).toFixed(2)}</td>
                          <td>₹{Number(user.totalSpending || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}</td>
                          <td><UserTagEditor userId={user._id} tags={user.tags || []}
                            onChange={(tags) => setUserList((current) => current.map((row) => row._id === user._id ? { ...row, tags } : row))} /></td>
                          <td>{customerTypeLabels[managementTab]}</td>
                          {managementTab === 2 && <td>{user.powerOrigin || "---"}</td>}
                          {managementTab === 2 && <td>{user.powerCustomerSince ? dateFormat(user.powerCustomerSince) : "---"}</td>}
                          <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={managementTab === 2 ? 19 : 17}
                    msg={`${customerTypeLabels[managementTab]} not found!`}
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
            <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center gap-3">
                                      <Typography variant="body2" color="textSecondary">
                                          Show:
                                      </Typography>
                                      <select
                                          value={pageLimit}
                                          onChange={(e) => handlePageLimitChange(e)}
                                          style={{ 
                                              padding: '8px 12px', 
                                              border: '1px solid #ccc', 
                                              borderRadius: '4px',
                                              fontSize: '14px',
                                              minWidth: '80px'
                                          }}
                                      >
                                          <option value={5}>5</option>
                                          <option value={10}>10</option>
                                          <option value={25}>25</option>
                                          <option value={50}>50</option>
                                          <option value={100}>100</option>
                                      </select>
                                      <Typography variant="body2" color="textSecondary">
                                           per page
                                      </Typography>
                                  </div>
                                  
                                  <div className="d-flex align-items-center gap-2">
                                      <Typography variant="body2" color="textSecondary">
                                          Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
                                      </Typography>
                                  </div>
                                  
                                 {total > 10 ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={pageLimit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}
                              </div>
          
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setListing={setUserList}
          setUserDetail={""}
          status={statusValue}
          id={statusId}
        />
      )}

      {logoutUserModel && (
        <ModalBox
          status={logoutUserModel}
          onClose={logoutCloseModel}
          title="Logout User from all Device"
          description="Do you want to logout the user from all the devices?"
          action={handleLogoutHandler}
          ref={buttonref}
        />
      )}

      <Dialog open={whatsappModal} onClose={closeWhatsappModal} fullWidth maxWidth="sm">
        <DialogTitle>
          WhatsApp Marketing — {customerTypeLabels[managementTab]}
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "12px !important" }}>
          <Typography variant="body2" color="text.secondary">
            {spendWindow?.startDate && spendWindow?.endDate
              ? `Only ${customerTypeLabels[managementTab].toLowerCase()}s whose spend from ${spendWindow.startDate} to ${spendWindow.endDate} matches this tab will receive the campaign.`
              : `All-time ${customerTypeLabels[managementTab].toLowerCase()}s matching the current filters will receive the campaign. Apply a spend date range to limit it.`}
          </Typography>
          <RadioGroup
            value={whatsappSendMode}
            onChange={(event) => setWhatsappSendMode(event.target.value)}
          >
            <FormControlLabel
              value="all"
              control={<Radio size="small" />}
              label={`Send to all matching (${total})`}
            />
            <FormControlLabel
              value="selected"
              control={<Radio size="small" />}
              label={`Send to selected (${selectedUserIds.length})`}
            />
          </RadioGroup>
          <TextField
            autoFocus
            required
            label="AiSensy campaign name"
            value={whatsappCampaignName}
            onChange={(event) => setWhatsappCampaignName(event.target.value)}
            placeholder="e.g. power_offer_oct"
            helperText="Exact campaign name as created in AiSensy."
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeWhatsappModal} disabled={sendingWhatsapp}>Cancel</Button>
          <Button
            variant="contained"
            disabled={sendingWhatsapp || !whatsappCampaignName.trim() || (whatsappSendMode === "selected" && !selectedUserIds.length) || (whatsappSendMode === "all" && !total)}
            onClick={handleSendWhatsapp}
            sx={{ bgcolor: "#ff8989", "&:hover": { bgcolor: "#ff6b6b" } }}
          >
            {sendingWhatsapp ? "Sending..." : "Send WhatsApp"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={notificationModal} onClose={closeNotificationModal} fullWidth maxWidth="md">
        <DialogTitle>
          Notify {selectedUserIds.length} selected {customerTypeLabels[managementTab]}(s)
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "12px !important" }}>
          <TextField
            autoFocus
            required
            label="English title"
            value={notificationData.title}
            onChange={(event) => setNotificationData((current) => ({ ...current, title: event.target.value }))}
            inputProps={{ maxLength: 120 }}
          />
          <TextField
            required
            multiline
            minRows={3}
            label="English message"
            value={notificationData.message}
            onChange={(event) => setNotificationData((current) => ({ ...current, message: event.target.value }))}
            inputProps={{ maxLength: 1000 }}
          />
          <TextField
            label="Hindi title"
            value={notificationData.titleHi}
            onChange={(event) => setNotificationData((current) => ({ ...current, titleHi: event.target.value }))}
            inputProps={{ maxLength: 120 }}
          />
          <TextField
            multiline
            minRows={3}
            label="Hindi message"
            value={notificationData.messageHi}
            onChange={(event) => setNotificationData((current) => ({ ...current, messageHi: event.target.value }))}
            inputProps={{ maxLength: 1000 }}
          />
          <TextField
            label="Kannada title"
            value={notificationData.titleKn}
            onChange={(event) => setNotificationData((current) => ({ ...current, titleKn: event.target.value }))}
            inputProps={{ maxLength: 120 }}
          />
          <TextField
            multiline
            minRows={3}
            label="Kannada message"
            value={notificationData.messageKn}
            onChange={(event) => setNotificationData((current) => ({ ...current, messageKn: event.target.value }))}
            inputProps={{ maxLength: 1000 }}
          />
          <TextField
            type="datetime-local"
            label="Schedule time (optional)"
            value={notificationData.scheduledAt}
            onChange={(event) => setNotificationData((current) => ({ ...current, scheduledAt: event.target.value }))}
            InputLabelProps={{ shrink: true }}
          />
          <Typography variant="caption" color="text.secondary">
            Send Now sends immediately. To schedule it, select a date and time and use Schedule.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeNotificationModal} disabled={sendingNotification}>Cancel</Button>
          <Button
            variant="outlined"
            disabled={sendingNotification || !notificationData.scheduledAt || !notificationData.title.trim() || !notificationData.message.trim()}
            onClick={() => handleSendNotification(true)}
          >
            Schedule
          </Button>
          <Button
            variant="contained"
            disabled={sendingNotification || !notificationData.title.trim() || !notificationData.message.trim()}
            onClick={() => handleSendNotification(false)}
            sx={{ bgcolor: "#ff8989", "&:hover": { bgcolor: "#ff6b6b" } }}
          >
            {sendingNotification ? "Sending..." : "Send Now"}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default UserManagement;
